import api from "./api";
import { UserType } from "../types/UserTypes";
import { AxiosError } from "axios";

export const create_user = async (data: UserType) => {
	try {
		const response = await api.post("/users", data);
		
		return response.data;
	} catch (error: AxiosError | any) {
		return error;
	}
};

export const list_users = async () => {
	try {
		const { data } = await api.get("/users");

		if (data.data) return data.data;
	} catch (error: AxiosError | any) {
		return error;
	}
};

export const get_user = async (id: number) => {
	try {
		const response = await api.get(`/user&id=${id}`);

		if (response.data) return response.data;
	} catch (error: AxiosError | any) {
		return error;
	}
};

export const edit_user = async (data: UserType) => {
	try {
		const response = await api.put(`/users&id=${data.id}`, data);

		if (response.data) return response.data;
	} catch (error: AxiosError | any) {
		return error;
	}
};

export const remove_user = async (id: number) => {
	try {
		const response = await api.delete(`/users&id=${id}`);
		
		if (response.data) return response.data;
	} catch (error: AxiosError | any) {
		return error;
	}
};
